module.exports = __webpack_public_path__ + "img/center_focus_strong.33c33c2a.svg";